
import { NoseurObject } from "@rivtn/noseur";
import { SanitizedResponse } from "../BaseService";
import { PloutousBaseService, PloutousStatus, PloutousTrail } from "./PloutousBaseService";

export interface ITransaction {
    tax: number;
    msisdn: string;
    amount: number;
    country: string;
    discount: number;
    reference: string;
    created_at: string;
    amount_paid: number;
    external_id: string;
    business_id: string;
    payer_email: string;
    service_code: string;
    language_code: string;
    charge_amount: number;
    status: PloutousStatus;
    transaction_id: string;
    request_amount: number;
    payer_last_name: string;
    trails: PloutousTrail[];
    refunded_amount: number;
    payer_first_name: string;
    payment_methods: string[];
    acknowledged_amount: number;
    charge_country_code: string;
    request_country_code: string;
    payer_account_number: string;
    charge_currency_code: string;
    request_currency_code: string;
    pay: {
        tax: number;
        amount: number;
        currency: string;
        discount: number;
        tax_percentage: number;
        discount_percentage: number;
    };
    redirects: {
        success: string;
        failure: string;
        partial: string;
    };
    configuration: {
        redirect_logic: string;
        can_change_msisdn: boolean;
        can_change_country: boolean;
        can_change_language: boolean;
        default_payment_method: string;
        refund_partial_payment: boolean;
        auto_redirect_wait_timeout: number;
    };
    extra_data: {
        service_name: string;
        business_name: string;
        tax_percentage: number;
        discount_percentage: number;
        request_payment_methods: string[];
        payment_processors: NoseurObject<{ name: string; amount: number; method: string;}>;
    };

}

export interface IManagedTransaction {
    url: string;
}

export class TransactionService extends PloutousBaseService {

    protected static instance: TransactionService;

    private constructor() {
        super();
    }

    static getInstance() {
        if (!TransactionService.instance) TransactionService.instance = new TransactionService();
        return TransactionService.instance;
    }

    queryTransactions(params: NoseurObject<string | number> = { page: 1, size: 10 }): Promise<any> {
        return this.report(this.transport.get("/api/v1/transaction", { query: this.normalizeParams(params) }));
    }

    getSingleTransaction(id: string): Promise<SanitizedResponse<ITransaction>> {
        return this.report(this.transport.get(`/api/v1/transaction/${id}`));
    }

    initiateTransaction(transaction: ITransaction): Promise<SanitizedResponse<IManagedTransaction>> {
        return this.report(this.transport.post("/api/v1/transaction/managed", transaction, this.config));
    }

}
